import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\FetchNewLogActivityController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchNewLogActivityController.php
* @route '/api/activity/new'
*/
const FetchNewLogActivityController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchNewLogActivityController.url(options),
    method: 'get',
})

FetchNewLogActivityController.definition = {
    methods: ["get","head"],
    url: '/api/activity/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ActivityLog\FetchNewLogActivityController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchNewLogActivityController.php
* @route '/api/activity/new'
*/
FetchNewLogActivityController.url = (options?: RouteQueryOptions) => {
    return FetchNewLogActivityController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\FetchNewLogActivityController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchNewLogActivityController.php
* @route '/api/activity/new'
*/
FetchNewLogActivityController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchNewLogActivityController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ActivityLog\FetchNewLogActivityController::__invoke
* @see app/Http/Controllers/ActivityLog/FetchNewLogActivityController.php
* @route '/api/activity/new'
*/
FetchNewLogActivityController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchNewLogActivityController.url(options),
    method: 'head',
})

export default FetchNewLogActivityController